import { NewsPage } from '../../types';
import ListingTemplate from './ListingTemplate';
import NewsList from '../NewsList';

const NewsListingPage = ({ data, ...post }: NewsPage) => (
  <ListingTemplate {...post}>
    <NewsList news={data} />
  </ListingTemplate>
);

export default NewsListingPage;
